<template>
  <div class="stat">
    <div class="stat-label">{{ label }}</div>
    <div class="stat-value" :class="{ accent }">{{ value }}<span v-if="suffix" class="stat-suffix"> {{ suffix }}</span></div>
  </div>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    // Smaller faint unit after the value ("3.4 GB" — mock F1 "Stored").
    suffix: { type: String, default: '' },
    // Terracotta value (mock highlights one stat per grid).
    accent: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
/* Mock F1/F2 stat card: card-alt surface, hairline, 7px radius, faint 12px
   label, Instrument Serif value. */
.stat {
  padding: 16px 18px;
  background: var(--card-alt);
  border: 1px solid var(--border);
  border-radius: 7px;
}
.stat-label {
  font-size: 11.5px;
  color: var(--faint);
  font-weight: 500;
  margin-bottom: 8px;
}
.stat-value {
  font-size: clamp(24px, 2.4vw, 30px);
  font-weight: 400;
  letter-spacing: -.01em;
  line-height: 1.05;
  font-family: var(--font-display);
  color: var(--text);
  overflow-wrap: anywhere;
}
.stat-value.accent { color: var(--accent); }
.stat-suffix { font-size: .55em; color: var(--faint); }
</style>
